module.exports = __webpack_public_path__ + "779ad34e4bb082852285760c42303d4f.png";